import React from 'react';
import styles from '../../styles/Building MGMT/UnitCard.module.css';

const UnitCard = ({ unit, onManageApplications, onCreateOffer , onViewDetails}) => {
  return (
    <div className={styles.unitCard}>
      <div className={styles.unitTitle}>
        🏠 Unit #{unit.number}
      </div>
      <div className={styles.unitDetails}>
        <span>🛏️ {unit.beds} Bd • 🛁 {unit.baths} Ba • 📏 {unit.sqft} SqFt</span>
        {unit.activeOnMILO && unit.rent ? (
          <>
            <span>💲 <strong>${unit.rent}/mo</strong></span>
            <span>📅 <strong>{unit.daysOnMarket || 0}</strong> days listed</span>
            <span>👀 <strong>{unit.views || 0}</strong> views</span>
            <span>🚶 <strong>{unit.tours || 0}</strong> tours</span>
            <span>📥 <strong>{unit.applications || 0}</strong> applications</span>
          </>
        ) : (
          <span className={styles.noOffer}>No Active Offer</span>
        )}
      </div>
      <div className={styles.actions}>
        {unit.activeOnMILO && unit.rent ? (
          <button 
            className={`${styles.actionButton} ${styles.manageButton}`}
            onClick={onManageApplications}
          >
            Manage Applications
          </button>
        ) : (
          <button 
            className={`${styles.actionButton} ${styles.createOfferButton}`}
            onClick={onCreateOffer}
          >
            Create Offer
          </button>
        )}
         <button 
          className={`${styles.actionButton} ${styles.viewButton}`}
          onClick={onViewDetails}
        >
          View Details
        </button>
      </div>
    </div>
  );
};

export default UnitCard;
